<template>
  <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="所属门店：">
        <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
          @change="search()">
          <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="销售单号：">
        <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.orderCode"
          placeholder="请输入销售单号"></el-input>
      </el-form-item>
      <el-form-item label="出库时间：">
        <el-date-picker clearable v-model="dateValue" size="small" type="daterange" value-format="yyyy-MM-dd"
          format="yyyy-MM-dd" @change="handleDateChange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">
          搜索
        </el-button>
        <el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
      </el-form-item>
    </el-form>
    <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border>
      <!--      
      <el-table-column v-if="isShowMoney" slot="price" label="单价" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}
        </template>
</el-table-column>
<el-table-column v-if="isShowMoney" slot="money" label="金额" width="100" align="center">
  <template slot-scope="scope">
          {{ scope.row.money }}
        </template>
</el-table-column> -->
    </STable>
    <!-- 分页组件 -->
    <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </topTab>
</template>

<script>
import { GetSalesOrderDtlList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "订单明细",
        }
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      storeList: [],
      dateValue: [],
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
        orderCode: "",
        storeKeyId: "",
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "createTime",
          label: "经办时间",
          align: "center",
          width: "160",
          fixed: "left",
        },
        {
          prop: "storeName",
          label: "所属门店",
          align: "center",
          fixed: "left",
          isKeep: true,
          width: "120",
        },
        {
          prop: "customerInfo.name",
          label: "客户名称",
          align: "center",
          width: "90",
          fixed: "left",
        },
        {
          prop: "specification",
          label: "商品名称",
          align: "center",
          minWidth: "180",
        },
        {
          prop: "price",
          label: "单价(元)",
          align: "center",
          isKeep: true,
          width: "80",
        },
        {
          prop: "typeName",
          label: "类型",
          align: "center",
          isKeep: true,
          width: "100",
        },
        {
          prop: "productName",
          label: "系列",
          align: "center",
          width: "150",
        },
        {
          prop: "quantity",
          label: "销售数量",
          align: "center",
          width: "80",
        },
        {
          prop: "money",
          label: "金额(元)",
          align: "center",
          width: "80",
        },
        {
          prop: "salesOrderInfo.code",
          label: "销售单号",
          align: "center",
          width: "180",
        },
        {
          prop: "salesOrderInfo.isConfirm",
          label: "是否确认",
          align: "center",
          width: "90",
          formatter: (row) => {
            return row.salesOrderInfo.isConfirm === true ? "是" : "否";
          }
        },
        {
          prop: "salesOrderInfo.confirmUserName",
          label: "确认人",
          align: "center",
          width: "90",
        },
        {
          prop: "salesOrderInfo.confirmDate",
          label: "确认时间",
          align: "center",
          width: "160",
        },
        {
          prop: "customerInfo.phone",
          label: "客户电话",
          align: "center",
          width: "120",
        },
        {
          prop: "customerInfo.customerNo",
          label: "客户编号",
          align: "center",
          width: "100",
        },
        {
          prop: "creator",
          label: "经办人",
          align: "center",
          width: "80",
        },
      ]
    };
  },
  // 注册组件
  components: {},
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.GetOrganizationListByConfig();
    this.search();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    handleDateChange(val) {
      if (val) {
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetSalesOrderDtlList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
            this.totalQuantity = res.totalQuantity;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 获取所属门店
    GetOrganizationListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            res.data.forEach((item) => {
              this.storeList.push({
                keyId: item.keyId,
                value: item.name + '【' + item.remark2 + '】',
              });
            });
            this.storeList.unshift({
              keyId: "",
              value: "所有门店",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>